import { Person } from "@/Common/Models/Person/Person";
import { RAMQInfo } from "@/Common/Models/RAMQ/RAMQInfo";
import { cacheStore } from "@/Globals/Stores/CacheStore";

export class RAMQClinicianRetriever {
    /**
     * Retrieves and orders RAMQ clinicians based on the following priority: (MYLE-9755)
     * 1. RAMQ IPS
     * 2. RAMQ Resident
     * 3. RAMQ Doctor
     *
     * @param ramqRegisteredClinician - The RAMQ registration information
     * @param includeEnrolledResidents - Whether to include enrolled residents in the result
     * @returns A list of clinicians ordered by priority
     */
    public static getRamqClinicians(ramqRegisteredClinician: RAMQInfo, includeEnrolledResidents: boolean = false): Person[] {
        if (!ramqRegisteredClinician) {
            return null;
        }

        const familyProviderLicence = ramqRegisteredClinician.Extract5DigitLicenceNumber();
        const ramqClinicians: Person[] = [];

        if (includeEnrolledResidents
            && !!ramqRegisteredClinician?.RAMQInscription?.ResidentPermit
            && !!ramqRegisteredClinician?.RAMQInscription?.ResidentClass
            && ramqRegisteredClinician.RAMQInscription.ResidentClass === "8"
        ) {
            const residentPermit = ramqRegisteredClinician.RAMQInscription.ResidentPermit;
            const clinician = this.getClinician("8", residentPermit);
            !!clinician && ramqClinicians.push(clinician);
        }

        if (includeEnrolledResidents
            && !!ramqRegisteredClinician?.RAMQInscription?.ResidentPermit
            && !!ramqRegisteredClinician?.RAMQInscription?.ResidentClass
            && ramqRegisteredClinician.RAMQInscription.ResidentClass === "5"
        ) {
            const residentPermit = `R${ramqRegisteredClinician.RAMQInscription.ResidentPermit}`;
            const clinician = this.getClinician("5", residentPermit);
            !!clinician && ramqClinicians.push(clinician);
        }

        const doctorClass = ramqRegisteredClinician.RAMQInscription?.DoctorClass;
        if (!IsNullOrWhiteSpace(familyProviderLicence)) {
            const clinician = this.getClinician(doctorClass, familyProviderLicence) ?? cacheStore.GetClinicianByRamqNumber(`${doctorClass}${familyProviderLicence}`);
            !!clinician && ramqClinicians.push(clinician);
        }

        return ramqClinicians;
    }

    private static getClinician(doctorClass: string, licenceNumber: string): Person {
        return RAMQInfo.activeProfessional(doctorClass, licenceNumber);
    }
}
